import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";
import * as AwsS3 from "../../inc/AwsS3";

export default function QrcodeLogoCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    const navigate = useNavigate();

    let [uploadFile, setUploadFile] = React.useState(false);
    let [currentFile, setCurrentFile] = React.useState(null);
    let [awsS3Config, setAwsS3Config] = React.useState([]);

    let refName = React.useRef();
    let refFileName = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                //region AWS S3
                const resAwsS3 = await AwsS3.getAwsS3();
                setAwsS3Config(resAwsS3);
                //endregion
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = () => {
        let name = refName.current.value;
        if(!name) {
            toast.error("กรุณาระบุ ชื่อภาพ");
            refName.current.focus();
        }
        else
        if(!uploadFile) {
            toast.error("กรุณาระบุ File Logo");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            //region AWS S3 Upload File
                            let fileName = null;
                            if(uploadFile) {
                                let fileValue = uploadFile.name;
                                let fileExt = fileValue.split('.').pop();
                                let newFilename = Utils.getFileName() + '.' + fileExt;
                                await AwsS3.uploadFile(awsS3Config, uploadFile, newFilename);
                                fileName = newFilename;
                            }
                            //endregion

                            const body = {
                                name: name,
                                fileName: fileName,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            fetch(Config.url.API_URL +'/api/qrcodeLogo/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/qrcodeLogo', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onSelectFile = (e) => {
        if(e && e.target && e.target.files[0]) {
            let KB = e.target.files[0].size;
            let MB = 1;
            if(KB && (KB/1000000) >= MB) {
                toast.error('ขนาดไฟล์ต้องไม่เกิน ' + MB + ' MB');
                e.target.value = '';
                setUploadFile(null);
            }
            else {
                setUploadFile(e.target.files[0]);

                let reader = new FileReader();
                reader.onload = function(e)
                {
                    setCurrentFile(e.target.result);
                };
                reader.readAsDataURL(e.target.files[0]);
            }
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Qr Code Logo</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อภาพ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className={"col-12" + (awsS3Config.status===1 ? '':' d-none')}>
                                <label htmlFor="uploadFile" className="form-label">File Logo <span className="text-danger">*</span></label>
                                <div className="input-group">
                                    <input type="file" className="form-control" id="uploadFile" onChange={(e) => {onSelectFile(e)}} accept="image/jpg" />
                                </div>
                                <p className="text-danger mb-0 mt-1 small">ต้องเป็นไฟล์ภาพ jpg ขนาด 50x50 pixel รูปแบบสี่เหลี่ยมจตุรัส ขนาดไม่เกิน 1 MB</p>

                                {
                                    currentFile ? <div className="my-2"><img src={currentFile} style={{width:'100%', maxWidth:50}} /></div> : ''
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>

                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/qrcodeLogo'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 